import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import ToolboxLayout from 'layouts/toolboxLayout';
import DynamicHero from 'components/Hero/DynamicHero';
import CardBlock from 'components/CardBlock';
import TwoColumnLayout from 'components/TwoColumnLayout';
import useToolsCards from 'hooks/useToolsCards';
import toolsIcon from 'images/tools-white.svg';
import HeroInlineProgressiveForm from 'components/Form/ProgressiveForm/HeroInlineProgressiveForm';

const ToolsPage = props => {
  const dynamicHero = props.data.contentfulDynamicHero;
  const demoForm = props.data.contentful2ColumnLayout;

  const cardsBlock = {
    bgColor: 'Transparent',
    cardType: 'Image',
    cards: useToolsCards(),
  };

  const breadcrumbs = {
    data: [
      {
        title: 'Toolbox',
        icon: null,
        url: '/toolbox',
      },
      {
        title: 'Tools',
        icon: toolsIcon,
        url: '',
      },
    ],
    absolute: true,
    transparent: true,
    theme: 'light',
  };

  return (
    <ToolboxLayout breadcrumbs={breadcrumbs} contentfulSeo={props.data.contentfulSeo} {...props}>
      <ToolboxDynamicHero
        data={dynamicHero}
        images={[]}
        dataPosition="Hero"
        formType="Email Capture"
        customInlineForm={<HeroInlineProgressiveForm buttonColor="primary" theme="light" />}
      />
      <ToolboxIconCardsSection>
        <CardBlock data={cardsBlock} cols={3} />
      </ToolboxIconCardsSection>
      <TwoColumnLayout
        leftAlignContent={demoForm.leftAlignContent}
        columnOne={demoForm.columnOne}
        columnTwo={demoForm.columnTwo}
        backgroundColor={demoForm.backgroundColor}
        cornerImage={demoForm.cornerImage}
        pageType={'normal'}
      />
    </ToolboxLayout>
  );
};

export default ToolsPage;

export const ToolsPageQuery = graphql`
  query ToolsPageQuery {
    contentfulSeo(contentful_id: { eq: "5LQc6qMm5LpSUOVAgcEC6r" }) {
      ...Seo
    }

    contentfulDynamicHero(contentful_id: { eq: "7hBjWAkQntk4YEQv7aw21M" }) {
      ...DynamicHero
    }

    contentful2ColumnLayout(contentful_id: { eq: "6eGRiTW0cZlDmpyQNooRwX" }) {
      leftAlignContent
      backgroundColor {
        backgroundColor
      }
      cornerImage
      columnOne {
        json
      }
      columnTwo {
        json
      }
    }
  }
`;

const ToolboxDynamicHero = styled(DynamicHero)`
  padding-top: 0;
  min-height: 550px;

  .section-layout--inner-container {
    padding-top: 150px;

    @media (max-width: 576px) {
      padding-top: 100px;
    }
  }

  @media (max-width: 680px) {
    height: auto;

    .hero-copy {
      margin-bottom: 0;
    }
  }
`;

const ToolboxIconCardsSection = styled.div`
  .st-cta-cards-section .card-row-container {
    margin-top: 0;

    .card-item {
      .card--cover {
        padding: 20px;
        min-height: auto;
      }
    }
  }
`;
